import { AnyProfile, FormFieldItem, FormFields } from '../../../types'
import {
  isValidDate,
  isValidEmail,
  isValidPhone,
} from '../DynamicFields/Validations'

export const peInfoFields = ({
  state,
  isNewUser,
}: {
  state: AnyProfile
  isNewUser: boolean
}): FormFields[] => {
  return [
    {
      title: 'Datos Personales',
      rowLeft: [
        {
          type: 'file',
          label: 'Añade una imagen',
          id: 'image',
          value: state.image ?? null,
          isSquareCrop: true,
        },
      ],
      rowRight: [
        {
          type: 'input',
          label: 'Nombre*',
          placeholder: state.name,
          id: 'name',
          value: state.name,
          isMandatory: true,
        },
        {
          type: 'input',
          label: 'Apellidos*',
          placeholder: state.lastname,
          id: 'lastname',
          value: state.lastname,
          isMandatory: true,
        },
        {
          type: 'phone',
          label: 'Telefono*',
          placeholder: state.phone,
          id: 'phone',
          value: state.phone,
          validation: {
            validate: isValidPhone,
            message: 'Número de teléfono inválido o código de país incorrecto.',
          },
          isMandatory: true,
        },
        {
          type: 'date',
          label: 'Fecha de nacimiento*',
          placeholder: state.birthDate,
          id: 'birthDate',
          value: state.birthDate,
          // disableFuture: true,
          isMandatory: true,
          validation: {
            validate: isValidDate,
            message: 'No es una fecha valida',
          },
          // fullWidth: true,
        },
        !isNewUser && {
          type: 'email',
          label: 'Email*',
          placeholder: state.email,
          id: 'email',
          value: state.email,
          validation: {
            validate: isValidEmail,
            message: 'No es un email válido.',
          },
          isMandatory: true,
        },
        state.title && {
          type: 'input',
          label: 'Titulo',
          placeholder: state.title,
          id: 'title',
          value: state.title,
          fullWidth: true,
        },
      ].filter(Boolean) as FormFieldItem[],
    },
  ]
}

export const newUserFields = ({
  state,
}: {
  state: AnyProfile
}): FormFields[] => {
  return [
    {
      title: 'Rol',
      rowRight: [
        {
          type: 'buttons',
          label: 'Rol',
          id: 'role',
          value: state.role,
          options: ['admin', 'professor', 'student'],
        },
      ],
    },
  ]
}

export const genreField = ({ state }: { state: AnyProfile }): FormFields[] => {
  return [
    {
      title: 'Género',
      rowRight: [
        {
          type: 'menu',
          label: 'genre',
          id: 'genre',
          value: state.genre,
        },
      ],
    },
  ]
}
